import React, { useEffect, useState } from "react";
import { FiFilter } from "react-icons/fi";
import { Dropdown } from "react-bootstrap";
import DropdownToggle from "react-bootstrap/DropdownToggle";
import DropdownMenu from "react-bootstrap/DropdownMenu";

import DateRangePickerCustom from "app/Components/DateTimeCustom/DateRangePickerCustom";
import DateTimePicker from "app/Components/DateTimeCustom/CustomDateTime";
import moment from "moment";
import { formatDate, parseDate } from "react-day-picker/moment";

const DateTimeFilter = (props) => {
  const [datetype, setDateType] = useState("");
  const [selectedDate, setSelectedDate] = useState("");

  function onChangeMonthYear(day, type) {
    var date = new Date(day);
    let toDate = new Date();
    let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    // day = ("0" + date.getDate()).slice(-2);
    // var finaldate = [date.getFullYear(), mnth, day].join("-");

    if (type === "YYYY") {
      var prevDate = "";
      var lastDate = "";
      var firstDate = "";
      if (
        moment(date.getFullYear() + "-12-31", "YYYY-MM-DD").format("YYYY-MM-DD") >
        moment(new Date()).format("YYYY-MM-DD")
      ) {
        prevDate = moment(new Date()).subtract(1, "days").format("YYYY-MM-DD");
        //lastDate= moment(new Date()).format("YYYY-MM-DD")
      } else {
        prevDate = moment(date.getFullYear() + "-12-31", "YYYY-MM-DD").format(
          "YYYY-MM-DD"
        );
        //lastDate= moment( date.getFullYear() + "-12-31","YYYY-MM-DD").format("YYYY-MM-DD")
      }

      // if(moment(date.getFullYear() + "-01-01","YYYY-MM-DD").format("YYYY-MM-DD") > moment(new Date()).format("YYYY-MM-DD")){
      //   firstDate= moment(new Date()).subtract(1, 'days').format("YYYY-MM-DD")
      // }else{
      //   firstDate= moment(date.getFullYear() + "-01-01","YYYY-MM-DD").format("YYYY-MM-DD")
      // }

      firstDate = moment(date.getFullYear() + "-01-01", "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      );
      lastDate = moment(date.getFullYear() + "-12-31", "YYYY-MM-DD").format("YYYY-MM-DD");
      setDateType("Year");
      props.getDate(firstDate, lastDate, "Year: " + date.getFullYear(), prevDate);
      setSelectedDate(date.getFullYear());
    } else if (type === "MM-YYYY") {
      setDateType("Month");
      let newDate = [mnth, date.getFullYear()].join("-");

      var firstDay = moment(new Date(date.getFullYear(), parseInt(mnth) - 1, 1)).format(
        "YYYY-MM-DD"
      );
      var lastDay = moment(new Date(date.getFullYear(), parseInt(mnth), 0))
        .clone()
        .endOf("month")
        .format("YYYY-MM-DD");

      var prevDate = "";
      var lastDate = "";
      var firstDate = "";
      if (
        moment(lastDay, "YYYY-MM-DD").format("YYYY-MM-DD") >
        moment(new Date()).format("YYYY-MM-DD")
      ) {
        prevDate = moment(new Date()).subtract(1, "days").format("YYYY-MM-DD");
        // lastDate= moment(new Date()).format("YYYY-MM-DD")
      } else {
        prevDate = moment(lastDay, "YYYY-MM-DD").format("YYYY-MM-DD");
        // lastDate=  moment(lastDay,"YYYY-MM-DD").format("YYYY-MM-DD")
      }

      firstDate = moment(firstDay, "YYYY-MM-DD").format("YYYY-MM-DD");
      lastDate = moment(lastDay, "YYYY-MM-DD").format("YYYY-MM-DD");

      // if(moment(firstDay,"YYYY-MM-DD").format("YYYY-MM-DD") > moment(new Date()).format("YYYY-MM-DD")){
      //   firstDate= moment(new Date()).subtract(1, 'days').format("YYYY-MM-DD")
      // }else{
      //   firstDate=  moment(firstDay,"YYYY-MM-DD").format("YYYY-MM-DD")
      // }

      props.getDate(firstDate, lastDate, "Year: " + date.getFullYear(), prevDate);
      setSelectedDate(newDate);
    } else if (type === "YYYY-MM-DD") {
      setDateType("Inception");
      let mnth_0 = ("0" + (toDate.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      var finaldate = [toDate.getFullYear(), mnth_0, day].join("-");
      props.getDate(
        "",
        "",
        "Year: " + date.getFullYear(),
        prevDate,
        moment(new Date()).subtract(1, "days").format("YYYY-MM-DD")
      );
      setSelectedDate(finaldate);
    }
  }

  function renderMonthInput(props, openCalendar) {
    return (
      <div>
        <input {...props} />
        <label onClick={openCalendar}>Month</label>
      </div>
    );
  }

  function renderYearInput(props, openCalendar) {
    return (
      <div>
        <input {...props} />
        <label onClick={openCalendar}>Year</label>
      </div>
    );
  }

  useEffect(() => {
    if (!props.clear) return;
    setDateType("");
    setSelectedDate("");
  }, [props.clear]);

  return (
    <div className="dateFilter_projectDash">
      <div className="daterangePopups">
        <DateTimePicker
          timeFormat={false}
          placeholder="Month - Year"
          // value={this.state.month_year}
          format="MM-YYYY"
          formatDate={formatDate}
          parseDate={parseDate}
          inputProps={{ placeholder: "Month-Year" }}
          onChange={(day) => onChangeMonthYear(day, "MM-YYYY")}
          renderInput={renderMonthInput}
          closeOnSelect={true}
          isValidDate={(e) => {
            return e.isBefore(new Date());
          }}
        />
        <DateTimePicker
          timeFormat={false}
          placeholder="Month - Year"
          // value={this.state.month_year}
          format="YYYY"
          formatDate={formatDate}
          parseDate={parseDate}
          inputProps={{ placeholder: "Year" }}
          onChange={(day) => onChangeMonthYear(day, "YYYY")}
          renderInput={renderYearInput}
          closeOnSelect={true}
          isValidDate={(e) => {
            return e.isBefore(new Date());
          }}
        />
        <DateRangePickerCustom
          startDate={""}
          endDate={""}
          handleSelect={(dates) => {
            if (!dates?.startDate || !dates?.endDate) return;

            console.log(dates);

            props.getDate(
              moment(dates.startDate).format("YYYY-MM-DD"),
              moment(dates.endDate).format("YYYY-MM-DD")
            );
          }}
        />
        <a
          href="javascript:void(0)"
          onClick={() => onChangeMonthYear(new Date(), "YYYY-MM-DD")}
        >
          {" "}
          Inception
        </a>
      </div>
    </div>
  );
};

export default DateTimeFilter;
